import { useSelector } from 'react-redux';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { Checkbox, Field, TextOutput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { MaximumDensityFrom } from '../types';

let ResultsSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }): JSX.Element => {
  const maximumDensityFromSetToNone =
    useSelector(createWorksheetSelector!('TheoreticalMaximumDensity.MaximumDensityFrom')) === MaximumDensityFrom.None;

  return (
    <NamePrefixModifier appendNamePrefix="Results">
      <ListFieldSection>
        <Field input={<TextOutput />} name="BulkDensity" />
        <Field input={<TextOutput />} visible={!maximumDensityFromSetToNone} name="TheoreticalMaximumDensity" />
        <Field input={<TextOutput />} visible={!maximumDensityFromSetToNone} name="RelativeCompaction" />
        <Field input={<TextOutput />} visible={!maximumDensityFromSetToNone} name="AirVoids" />
      </ListFieldSection>
      <ListFieldSection heading="Report" visible={!maximumDensityFromSetToNone}>
        <Field input={<Checkbox />} name="ReportAirVoids" />
      </ListFieldSection>
    </NamePrefixModifier>
  );
};

const ResultsSection = withInjectedProps(ResultsSectionBase);
export { ResultsSection };
export default ResultsSection;
